export const normalizeStatus = (
  s?: string,
): 'Verified' | 'Pending' | 'waiting-for-approval' | 'Created' | 'verificationneeded' => {
  if (!s) return 'Pending';
  const val = s.toLowerCase();
  if (val.includes('waiting')) return 'waiting-for-approval';
  if (val.includes('verified')) return 'Verified';
  if (val.includes('verificationneeded')) return 'verificationneeded';
  if (val.includes('created') || val.includes('signed')) return 'Pending';
  return 'Pending';
};
